import { defineStore } from "pinia";
import { fetchCurrentUser, fetchUsers, updateCurrentUser } from "@/api/sight-back/user";

export const useUserStore = defineStore("user", {
  state: () => ({
    users: [],
    current: null,
  }),

  actions: {
    async fetchAll() {
      this.users = await fetchUsers();
    },

    async loadCurrentUser() {
      if (this.current) return;
      this.current = await fetchCurrentUser();
    },

    async updateFavoriteCountries(favoriteCountries) {
      this.current = await updateCurrentUser({ favoriteCountries });
    },
  },

  getters: {
    userOptions: (state) =>
      state.users.map((user) => ({
        title: `${user.firstName} ${user.lastName}`.trim(),
        value: user.uuid,
      })),

    groups: (state) => state.current?.groups ?? [],

    favoriteCountries: (state) => state.current?.favoriteCountries ?? [],
  },
});
